interface DocsPageHeaderProps {
  badge: string;
  title: string;
  description?: string;
  titleSize?: 'default' | 'large';
  updatedAt?: string;
  logo?: string;
}

export function DocsPageHeader({ badge, title, description, titleSize = 'default', updatedAt, logo }: DocsPageHeaderProps) {
  const titleClass =
    titleSize === 'large'
      ? 'text-3xl font-bold tracking-tight text-foreground sm:text-4xl'
      : 'text-2xl font-bold tracking-tight text-foreground sm:text-3xl';

  if (logo) {
    return (
      <section className="rounded-2xl border border-border bg-gradient-to-br from-card to-card/80 px-6 py-6 shadow-sm ring-1 ring-black/5 dark:ring-white/5">
        <div className="flex items-center gap-5 sm:gap-6">
          <span className="inline-flex h-20 w-20 sm:h-24 sm:w-24 flex-shrink-0 items-center justify-center rounded-3xl bg-white ring-1 ring-black/5 shadow-sm">
            <img src={logo} alt="" className="h-12 w-12 sm:h-14 sm:w-14 object-contain" loading="lazy" />
          </span>
          <div className="flex flex-col gap-2">
            <h1 className={titleClass}>{title}</h1>
            {description && (
              <p className="max-w-3xl text-base leading-relaxed text-muted-foreground">
                {description}
              </p>
            )}
            {updatedAt && (
              <p className="text-xs text-muted-foreground">{updatedAt}</p>
            )}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="rounded-2xl border border-border bg-gradient-to-br from-card to-card/80 px-6 py-6 shadow-sm ring-1 ring-black/5 dark:ring-white/5">
      <div className="flex flex-col gap-3">
        <span className="inline-flex w-fit items-center rounded-full bg-primary/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-primary">
          {badge}
        </span>
        <h1 className={titleClass}>
          {title}
        </h1>
        {description && (
          <p className="max-w-3xl text-base leading-relaxed text-muted-foreground">
            {description}
          </p>
        )}
        {updatedAt && (
          <p className="text-xs text-muted-foreground">{updatedAt}</p>
        )}
      </div>
    </section>
  );
}
